
import { ILanguage } from '@models/languages/language';

export class ArtistTranslation {
    biography_json: { [key: string]: string };
    description_json: { [key: string]: string };
    keywords_json: { [key: string]: string };
    constructor(languages: ILanguage[]) {
        languages.forEach(language => {
            this.biography_json = {
                ...this.biography_json,
                [language.code]: ''
            };
            this.description_json = {
                ...this.description_json,
                [language.code]: ''
            };
            this.keywords_json = {
                ...this.keywords_json,
                [language.code]: ''
            };
        });
    }
}
